import { BMPrimitives } from "@traveloka/district-bloom";
import { useCallback, useEffect, useRef } from "react";
import { Animated, Easing } from "react-native";

export const MAX_HEIGHT_OPTIONS_CONTAINER = 250;

export function useGetValue<T>(getOptionValue?: (value: T) => string) {
  return useCallback(
    (value?: T | null): string => {
      if (value == null) return "";
      if (typeof value === "string") return value;
      if (!getOptionValue) {
        console.error(
          "[BMDropdownDesktopOptions] Missing getOptionValue for non-string value",
          { value }
        );
        return "";
      }
      return getOptionValue(value);
    },
    [getOptionValue]
  );
}

export function useAnimatedDropdownHeight(
  show: boolean,
  contentHeight: number
) {
  const height = useRef(new Animated.Value(0)).current;

  useEffect(() => {
    const { BMAnimation } = BMPrimitives;
    const transition = show
      ? BMAnimation.transition.easeOutBounce
      : BMAnimation.transition.easeInOut;

    Animated.timing(height, {
      toValue: show ? Math.min(contentHeight, MAX_HEIGHT_OPTIONS_CONTAINER) : 0,
      duration: BMAnimation.duration.moderate,
      easing: Easing.bezier(
        transition.x1,
        transition.y1,
        transition.x2,
        transition.y2
      ),
      useNativeDriver: false,
    }).start();
  }, [show, contentHeight, height]);

  return height;
}
